import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Select from "react-select";
import { dictionaryCRUD } from "../../../../actions/dictionary";

export const Personal = (props) => {
  const { data, next, step1, setStep1, schema } = props;

  const [gender, setGender] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      dictionaryCRUD
        .loadDictionaryData(10, 0, "", 1)
        .then((resp) => {
          setGender(resp.data.results);
        })
        .finally(() => {});
    }, 500);
  }, []);

  // Helper function to find selected option from list
  const findSelectedOption = (list, value) => {
    if (!value || !list || list.length === 0) return null;
    const item = list.find(dt => dt.id === value || dt.id === parseInt(value));
    return item ? { value: item.id, label: item.dictionary_item_name_en } : null;
  };

  const handleSubmite = (values) => {
    next(values, false);
    setStep1(!step1);
  };

  return (
    <>
      <Formik
        initialValues={data}
        onSubmit={handleSubmite}
        validationSchema={schema}
        enableReinitialize={true}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <div
              className={!step1 ? "tab-pane fade show active" : "tab-pane fade"}
              id="step-personal-info"
              role="tabpanel"
              aria-labelledby="step-personal-tab"
            >
              <div>
                <div className="row">
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="fullName" className="form-label">
                        Full Name <span className="text-danger">*</span>
                      </label>
                      <Field
                        type={"text"}
                        className="form-control"
                        placeholder="Full name"
                        name="full_name"
                      />
                      <div
                        className="fw-light h6 mt-1"
                        style={{ fontSize: "15px" }}
                      >
                        <span role="alert" className="text-danger">
                          <ErrorMessage name="full_name" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="dob" className="form-label">
                        Date of Birth <span className="text-danger">*</span>
                      </label>
                      <Field
                        type={"date"}
                        className="form-control"
                        name="dob"
                      />
                      <div
                        className="fw-light h6 mt-1"
                        style={{ fontSize: "15px" }}
                      >
                        <span role="alert" className="text-danger">
                          <ErrorMessage name="dob" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="placeOfBirth" className="form-label">
                        Place of Birth <span className="text-danger">*</span>
                      </label>
                      <Field
                        type={"text"}
                        className="form-control"
                        placeholder="Place of Birth"
                        name="pob"
                      />
                      <div
                        className="fw-light h6 mt-1"
                        style={{ fontSize: "15px" }}
                      >
                        <span role="alert" className="text-danger">
                          <ErrorMessage name="pob" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="phone_number" className="form-label">
                        Phone Number{" "}
                      </label>
                      <Field
                        type={"text"}
                        className="form-control"
                        placeholder="+255XXXXXXXXX"
                        name="phone_number"
                      />
                      <div
                        className="fw-light h6 mt-1"
                        style={{ fontSize: "15px" }}
                      >
                        <span role="alert" className="text-danger">
                          <ErrorMessage name="phone_number" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="emaila_ddress" className="form-label">
                        Email Address
                      </label>
                      <Field
                        type={"text"}
                        className="form-control"
                        placeholder="Email Address"
                        name="emaila_ddress"
                      />
                      <div
                        className="fw-light h6 mt-1"
                        style={{ fontSize: "15px" }}
                      >
                        <span role="alert" className="text-danger">
                          <ErrorMessage name="emaila_ddress" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="gender" className="form-label">
                        Gender <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={gender?.map((dt) => ({
                          value: dt.id,
                          label: dt.dictionary_item_name_en,
                        }))}
                        value={findSelectedOption(gender, values.dictionary_gender)}
                        placeholder="Select gender"
                        onChange={(e) =>
                          setFieldValue("dictionary_gender", e.value)
                        }
                        isSearchable={true}
                        name="dictionary_gender"
                      />
                      <div
                        className="fw-light h6 mt-1"
                        style={{ fontSize: "15px" }}
                      >
                        <span role="alert" className="text-danger">
                          <ErrorMessage name="dictionary_gender" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-start gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-success btn-label right ms-auto nexttab nexttab"
                >
                  <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                  Next
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
